var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.487,
    height: 12.093,
    viewBox: "0 0 19.487 12.093",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 9.243 6.047)",
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("line", {
    id: "svg_2",
    x1: 4.516,
    y1: 6.09,
    strokeWidth: "2px",
    strokeLinecap: "round",
    stroke: "#777E91",
    fill: "none",
    y2: 6.093,
    x2: 18.486
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    transform: "rotate(-90 -2.64301e-7 12.093)",
    fill: "#777E91",
    d: "m6.046,12.093l6.046,7.774l-12.092,0l6.046,-7.774z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight);
export default __webpack_public_path__ + "static/media/icon-arrow-right.ed69dbf7ab3d739779217185e2d1f0f3.svg";
export { ForwardRef as ReactComponent };